import logo from '../assets/logo.svg';
import React from "react";
import HomeLayout from '../style/HomeLayout';
import links from '../data/links.json';

const Home = () => {
  return (
    <HomeLayout>
      <main>
          {/* containter above the navigation menus holdigng the logo */}
          <div className='logo-container'>
            <img src={logo} alt="Logo" className="logo"/>
            <span className="logo-text group">
              {'noah-flood.com'.split('').map((char, i) => (
                <span key={i} className={`inline-block`}>
                  {char}
                </span>
              ))}
            </span>
          </div>

          <p>Welcome to my ePortfolio.</p>

          {/* navigation items */}
          <div className='nav-container'>
            {/* for example
            <div className='nav-item'>/other item</div>
            */}
            {/* this would be to link to the actual writing center page 
            <Link to="/miller-writing-center" className='nav-item'>/miller-writing-center</Link>
            */}
            <a href={links["photography-link"]} className='nav-item' target="_blank" rel="noopener noreferrer">/photography</a>
            <a href={links["resume-path"]} className='nav-item' target="_blank" rel="noopener noreferrer">/resume</a>
          </div>
      </main>
    </HomeLayout>
  );
};

export default Home;